angular.module('dpw.components').component('dpwCredentialsJson', {
    templateUrl: 'dpw-credentials-json.component.html',
    controllerAs: 'ctrl',
    bindings: {
        application: '<',
        appKeys: '<',   
        canManipulateApp: '<',
    },
    controller: ['appKeyStatus', '$q', 'api', 'jsonDownloadService', '$filter', 'applicationService',
        function (appKeyStatus, $q, api, jsonDownloadService, $filter, applicationService) {
            var self = this;
            var JSON_FILE_NAME = 'rc-credentials.json'

            self.noPermissionMsg = RCDPW.Lang.MyAccount.RolePermission.INSUFFICIENT_PRIVILEGES;

            self.onDownload = function () {
                $q.all([
                    getProdCredentials(), 
                    getUsernameAndExtension(),
                    getWebhookInfo()
                ]).then(function (results) {
                    var prodCredentials = results[0];
                    var usernameAndExtension = results[1];
                    var webhookInfo = results[2];

                    var clientId = getClientId();
                    var clientSecret = getClientSecret(prodCredentials);
                    var server = 'https://platform.ringcentral.com';
                    var username = usernameAndExtension.username;
                    var extension = usernameAndExtension.extension;
                    var password = '<YOUR ACCOUNT PASSWORD>';
                    var jwt = getJwt(prodCredentials);
                    var redirectURI = getRedirectURI();
                    var webhookURI = webhookInfo.webHookUrl;
                    var webhookVerificationToken = webhookInfo.verifyCode;

                    var commonJsonContent = {
                        clientId: clientId,
                        clientSecret: clientSecret,
                        server: server,
                        webhookURI: webhookURI,
                        webhookVerificationToken: webhookVerificationToken,
                        jwt: jwt,
                        redirectURI: redirectURI
                    };

                    var jsonContentForPasswordFlow = {
                        username: username,
                        extension: extension,
                        password: password
                    };

                    if (isUsingPasswordFlow()) {
                        jsonDownloadService.download(JSON_FILE_NAME, _.assign({}, commonJsonContent, jsonContentForPasswordFlow));
                        return;
                    }

                    jsonDownloadService.download(JSON_FILE_NAME, commonJsonContent);
                });
            };

            function getProdKeys(appKeys) {
                return _.filter(appKeys, function (appKey) {
                    return appKey.isProduction;
                });
            }

            function isProdKeyAvailable(appKey) {
                var status = _.get(appKey, 'status');
                
                if (!status) {
                    return false;
                }

                return ![appKeyStatus.INITIAL, appKeyStatus.PENDING].includes(status);
            }

            function getAvailableProdKey() {
                var prodKeys = getProdKeys(self.appKeys);
                return _.find(prodKeys, isProdKeyAvailable);
            }

            function getProdCredentials() {
                var availableProdKey = getAvailableProdKey();

                if (availableProdKey) {
                    return $q(function (resolve, reject) {
                        api.call(api.myAccount.keys.getProdCredentials({
                            id: availableProdKey.id,
                            noLoading: true
                        }), function (data) {
                            resolve(data);
                        }, function (_, defaultErrorHandler) {
                            defaultErrorHandler();
                            reject();
                        });
                    });
                }

                return $q.resolve({});
            }

            function getClientId() {
                var availableProdKey = getAvailableProdKey();

                if (availableProdKey) {
                    return availableProdKey.key;
                }

                return RCDPW.Lang.NOT_AVAILABLE;
            }

            function getClientSecret(prodCredentials) {
                return _.get(prodCredentials, 'secret', RCDPW.Lang.NOT_AVAILABLE);
            }

            function getProdAccount() {
                return $q(function (resolve, reject) {
                    api.call(api.myAccount.developers.get(), function (data) {
                        resolve(data);
                    }, function (_, defaultErrorHandler) {
                        defaultErrorHandler();
                        reject();
                    });
                });
            }

            function getExtension(isNumberless) {
                if (isNumberless) {
                    return $q.resolve(RCDPW.Lang.NOT_AVAILABLE);
                }

                return $q(function (resolve, reject) {
                    api.call(api.myAccount.getSystemExtension({
                        noLoading: true
                    }), function (data) {
                        resolve(data.extension);
                    }, function (_, defaultErrorHandler) {
                        defaultErrorHandler();
                        reject();
                    });
                });
            }

            function getUsernameAndExtension() {
                var developerRes;
                var username;
                var extension;

                return getProdAccount().then(function (data) {
                    developerRes = data;
                }).then(function () {
                    username = developerRes.mainNumber
                        ? $filter('prefixPlus')(developerRes.mainNumber)
                        : developerRes.developer.email;
                }).then(function () {
                    var isNumberless = !developerRes.mainNumber;
                    return getExtension(isNumberless);
                }).then(function (ext) {
                    extension = ext;
                }).then(function () {
                    return {
                        username: username,
                        extension: extension
                    };
                });
            }

            function getJwt(prodCredentials) {
                var labelJwtMapping = (prodCredentials.jwts || [])
                    .filter(function (item) {
                        return Boolean(item.jwt);
                    })
                    .reduce(function (acc, item) {
                        var labelJwtMappingForItem = {};
                        labelJwtMappingForItem[item.label] = item.jwt;
                        return _.assign(acc, labelJwtMappingForItem);
                    }, {});

                if (_.isEmpty(labelJwtMapping)) {
                    return;
                }

                return labelJwtMapping;
            }

            function getWebhookInfo() {
                if (applicationService.isBotApp(self.application)) {
                    return $q(function (resolve, reject) {
                        api.call(api.myAccount.webhookInfo.get({
                            applicationId: self.application.id,
                            noLoading: true
                        }), function (data) {
                            var webhookEnabled = _.get(data, 'webHookInfo.enabled', false);
                            var webhookInfo = webhookEnabled ? data.webHookInfo : {};
                            resolve(webhookInfo);
                        }, function (_, defaultErrorHandler) {
                            defaultErrorHandler();
                            reject();
                        });
                    });
                }

                return $q.resolve({});
            }

            function getRedirectURI() {
                if (_.isEmpty(self.application.redirectUris)) {
                    return;
                }

                return self.application.redirectUris;
            }

            function isUsingPasswordFlow() {
                const grantTypes = _.get(self.application, 'grantTypes', []);
                return _.includes(grantTypes, 'ROPC');
            }
    }]
});
